module.exports = __webpack_public_path__ + "static/media/Prosperin.cc613295.png";